export default __webpack_public_path__ + "static/media/main.8d5da82a.jpg";